<template>
	<div>
		<el-table id="codeListTable" :data="tableData" size="mini" v-on:filter-change="filterChange" style="width: 100%">
			<el-table-column type="index" label="序号" width="50"> </el-table-column>
			<el-table-column prop="value" label="码号"> </el-table-column>
			<el-table-column
				label="码状态"
				width="120"
				column-key="status"
				align="center"
				:filters="[
					{text: '未使用', value: 0},
					{text: '正常', value: 1},
					{text: '有重码', value: 2},
				]"
				filter-placement="bottom-end"
			>
				<template slot-scope="scope">
					<el-tag size="medium" :type="getTagType(scope.row.is_used)">{{ getStatus(scope.row.is_used) }}</el-tag>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination layout="prev, pager, next, total" :page-count="pageCount" :size="pageSize" @current-change="currentChange"> </el-pagination>
	</div>
</template>

<script>
	import * as codePackRequest from '@/network/requests/codePack'
	export default {
		props: {
			codePackageId: {
				type: String,
				required: true,
			},
		},
		data() {
			this.status = {
				0: {title: '未使用', color: 'info'},
				1: {title: '正常', color: 'success'},
				2: {title: '有重码', color: 'danger'},
			}

			return {
				tableData: [],
				currentRow: null,
				filterIsUsed: [0, 1, 2],
				pageCount: 1,
				pageSize: 10,
				pageIndex: 1,
			}
		},
		watch: {
			codePackageId(val) {
				if (!val) return

				console.log('code package', val)

				this.requestCodeList()
			},
		},
		methods: {
			getTagType(is_used) {
				return this.status[is_used].color
			},
			getStatus(used) {
				return this.status[used].title
			},
			requestCodeList() {
				codePackRequest.queryCodeInfoOfCodePack(this.pageSize, this.pageIndex, this.codePackageId, this.filterIsUsed).then(({data}) => {
					//console.log(res)
					this.tableData = data._embedded
					this.pageCount = data._total_pages
				})
			},
			currentChange(pageIndex) {
				this.pageIndex = pageIndex
				this.requestCodeList()
			},
			filterChange(filterInfo) {
				this.filterIsUsed = filterInfo.status
				this.requestCodeList()
			},
		},
		created() {
			if (this.codePackageId) {
				this.requestCodeList()
			}

			//this.$refs.codeListTable.clearFilter()
		},
	}
</script>

<style></style>
